import script from "./SectionTemplateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionTemplateModal.vue?vue&type=script&setup=true&lang=ts"

import "./SectionTemplateModal.vue?vue&type=style&index=0&id=83592bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83592bee"]])

export default __exports__